export default __webpack_public_path__ + "slices/main/assets/public/media/home/development-playbooks-content@2x.27bfc7899e0c4477e1380cbed4a91234.png";